module.exports = new __parcel__URL__("Silkscreen-Regular.341186eb.ttf").toString();